export default __webpack_public_path__ + "static/media/icon-head-atmos.321b1035.png";